import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type MatterAssignee } from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

type CreateMatterAssigneePayload = {
  dateTimeEnd?: string | null;
  dateTimeStart: string;
  description?: string | null;
  matterId: string;
  roleId: string;
  userId: string;
};

type UpdateMatterAssigneePayload = {
  dateModified: string;
  dateTimeEnd?: string;
  dateTimeStart?: string;
  description?: string;
  id: string;
  matterId: string;
  roleId?: string;
};

export const createMatterAssignee = (data: CreateMatterAssigneePayload) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterAssignee>
    >(`${baseFastApiMatterRoute}/assignees`, data)
    .then((res) => res.data);
};

export const updateMatterAssignees = (data: {
  matterId: string;
  assignees: { userId: string; roleId: string; primaryContact: boolean }[];
}) =>
  authenticatedFastApiAxiosInstance
    .put<
      APIResponse<{
        matterId: string;
        createdIds: string[];
        deletedIds: string[];
      }>
    >(`${baseFastApiMatterRoute}/assignees/bulk`, data)
    .then((res) => res.data);

export const updateMatterAssigneeV1 = (data: UpdateMatterAssigneePayload) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterAssignee>
    >(`${baseFastApiMatterRoute}/assignees`, data)
    .then((res) => res.data);
};

export const deleteMatterAssigneeV1 = (data: { assigneeId: string }) => {
  const { assigneeId } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterAssignee>
    >(`${baseFastApiMatterRoute}/assignees/${assigneeId}`)
    .then((res) => res.data);
};
